import React, { CSSProperties, ReactNode } from 'react';

import DocumentPage, { DocumentPageProps } from './DocumentPage';

export interface DocumentPreviewPageProps extends DocumentPageProps {
  scale?: number;
  style?: {
    marginBottom?: number;
    width?: number;
    height?: number;
  };
  children?: ReactNode;
}

const DocumentPreviewPage = ({
  pageNumber,
  scale = 1,
  style,
  children,
  ...documentPageProps
}: DocumentPreviewPageProps) => {
  const scaledWidth = (style?.width as number) * scale;
  const scaledHeight = (style?.height as number) * scale;

  const wrapperStyles: CSSProperties = {
    marginBottom: style?.marginBottom || 20,
    width: scaledWidth,
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  return (
    <div className="documentPage__preview-item-wrapper" style={wrapperStyles}>
      <DocumentPage
        pageNumber={pageNumber}
        className="documentPage__preview-item"
        scale={scale}
        enableCustomMobileRenderer={false}
        style={{
          width: scaledWidth,
          height: scaledHeight,
        }}
        {...documentPageProps}
      />
      <div
        className="documentPage__preview-content"
        style={{
          transform: `scale(${scale})`,
          width: style?.width,
          height: style?.height,
          pointerEvents: 'auto',
          margin: '0 auto',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default DocumentPreviewPage;
